import store from '../store';
import Items from '../views/amazon/Index.vue';
import Unmatched from '../views/marketplace/Unmatched.vue';
import PriceAnalysis from '../views/amazon/PriceAnalysis.vue';
import { checkauth } from '../Helper';
import marketplaceTools from './marketplaceTools';

const MarketplaceSync = () => import('../views/marketplace/SyncPage.vue');

export default [
	{
		path: '/amazon',
		name: 'amazon',
		component: Items,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/amazon/associa',
		name: 'amazon-unmatched',
		component: Unmatched,
		// la stessa view serve anche eBay: la piattaforma arriva da qui
		meta: { platform: 'amazon' },
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/amazon/analisi-prezzi',
		name: 'amazon-price-analysis',
		component: PriceAnalysis,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	// associazione di una pubblicazione Amazon/eBay a un prodotto (da Associa prodotti e Notifiche):
	// pagina, non piu' finestra
	{
		path: '/marketplace/associa/:platform(amazon|ebay)',
		name: 'marketplace-sync',
		component: MarketplaceSync,
		beforeEnter(to, from, next) {
			checkauth().then(response => (response ? next() : next('/login')));
		},
	},
	...marketplaceTools('amazon'),
];
